import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SharedService } from '@core/services/shared.service';
import { customEcommerce } from 'src/assets/custom-ecommerce/custom';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';

const TICKETING_URLS: Record<string, string> = {
  it: 'https://www.ciaotickets.com/it/biglietteria-elettronica',
  en: 'https://www.ciaotickets.com/en/electronic-ticketing',
  de: 'https://www.ciaotickets.com/de/elektronischer-ticketverkauf',
  es: 'https://www.ciaotickets.com/es/billete-electrónico',
  fr: 'https://www.ciaotickets.com/fr/billetterie-électronique',
  pt: 'https://www.ciaotickets.com/pt-pt/bilhetagem-eletrônica',
  el: 'https://www.ciaotickets.com/el/ηλεκτρονική-έκδοση-εισιτηρίων',
  ru: 'https://www.ciaotickets.com/ru/электронная-продажа-билетов',
  ro: 'https://www.ciaotickets.com/ro/bilete-electronice',
  sq: 'https://www.ciaotickets.com/sq/bileta-elektronike'
};

const TERMS_URLS: Record<string, string> = {
  it: 'https://www.ciaotickets.com/it/termini-e-condizioni',
  en: 'https://www.ciaotickets.com/en/terms-and-conditions',
  de: 'https://www.ciaotickets.com/de/geschäftsbedingungen',
  es: 'https://www.ciaotickets.com/es/términos-y-condiciones',
  fr: 'https://www.ciaotickets.com/fr/termes-et-conditions',
  pt: 'https://www.ciaotickets.com/pt-pt/termos-e-condições',
  el: 'https://www.ciaotickets.com/el/οροι-και-προϋποθέσεις',
  ru: 'https://www.ciaotickets.com/ru/условия-и-положения',
  ro: 'https://www.ciaotickets.com/ro/termeni-și-condiții',
  sq: 'https://www.ciaotickets.com/sq/termat-dhe-kushtet'
};

const PRIVACY_LINKS: { label: string, url: string | Record<string, string> }[] = [
  {label : 'general.bigletteria' , url : TICKETING_URLS},
  {label : 'general.optional_terms_link' , url : TERMS_URLS},
  {label : 'general.privacy' , url : 'https://www.ciaotickets.com/{lang}/privacy-policy'},
  {label : 'general.cookie' , url : 'https://www.ciaotickets.com/{lang}/cookie-policy'}
];

@Component({
    selector: 'app-custom-footer',
    templateUrl: './custom-footer.component.html',
    styleUrls: ['./custom-footer.component.scss'],
    imports: [NgClass, NgStyle, TranslateModule,NgIf,NgFor]
})
export class CustomFooterComponent implements OnInit,AfterViewInit {
  private sharedService = inject(SharedService);
  private sanitizer = inject(DomSanitizer);
  private translate = inject(TranslateService);


  footerData : any;
  sanitizedPaths: { [key: string]: SafeResourceUrl } = {};
  sanitizedPathsCT: { [key: string]: SafeResourceUrl } = {};
  isWebMobile : boolean = false
  @ViewChild('custom', { static: false }) custom!: ElementRef;
  @ViewChild('customm', { static: false }) customm!: ElementRef;
  @ViewChild('swiperRef', { static: false }) swiperRef!: ElementRef<HTMLDivElement>;
  swiperEl : any
  swiperParams : any
  groupedPartners

  constructor() { 
    this.footerData = customEcommerce[this.sharedService.getCustomDomain()]
    this.footerData.footer.social.forEach((social) => {
      this.sanitizedPaths[social.url] = this.sanitizer.bypassSecurityTrustResourceUrl(social.path);
    });
    this.footerData.footer.socialCt.forEach((social) => {
      this.sanitizedPathsCT[social.url] = this.sanitizer.bypassSecurityTrustResourceUrl(social.path);
    });
  }

  ngAfterViewInit(): void {
    this.custom.nativeElement.style.background = this.footerData.footer.footerColor
    this.customm.nativeElement.style.background = this.footerData.footer.footerPartnerColor
    const links = this.custom.nativeElement.querySelectorAll('a');
    links.forEach((link: HTMLAnchorElement) => {
      link.style.setProperty('color', `${this.footerData.headerAndFooterTextColor}`, 'important');
    });
  }

  ngOnInit() {
    this.groupedPartners = this.chunkArray(this.footerData.footer.partnersImages, 2)
    
    this.getIsWebMobile();
  }


  redircttoPath(path){
    window.open(path,'blank')
  }


  onSvgLoad(svgObject: HTMLElement, fillColor: string): void {
    const svg = svgObject as HTMLObjectElement;
    const svgDocument = svg.contentDocument;
    if (svgDocument) {
      const path = svgDocument.querySelector('path');
      if (path) {
        path.setAttribute('fill', fillColor);
      }
    }
  }

  redirectto(url){
    window.open(
      url,
      '_blank'
  );
    
  }
  get privacyLinks() {
    const lang = this.translate.currentLang || this.translate.getDefaultLang() || 'it';
    return PRIVACY_LINKS.map(link => ({
      ...link,
      url: typeof link.url === 'string' ? link.url.replace('{lang}', lang) : (link.url[lang] || link.url['it'])
    }));
  }

  getIsWebMobile() {
    this.isWebMobile = window.innerWidth < 576;
  }


  chunkArray(array: any[], size: number): any[][] {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}
}
